import React, { Component } from 'react';
import Modal from 'js/components/global/Modal';
import { PaymentContext } from 'js/components/step5/PaymentContext';

class CardVerificationValueModalWrapper extends Component {
  render() {

    return (
      <PaymentContext.Consumer>
        {(context) => (
          <Modal
            className="vw-pay fok-title"
            isOpen={context.state.isModalOpen.cvv}
            onAfterOpen={this.afterOpenModal}
            onRequestClose={context.closeModal('cvv')}
            contentLabel="CVV ID Modal"
          >
            <div className="cvv-modal">
              <h2 className="popup-title">CREDIT CARD VERIFICATION VALUE
                <span className="cvv-subtitle"> (CVV, CVC2)</span>
              </h2>
              <div className="row">
                <div className="sm-12 md-6">
                  <div className="grey-block">
                    <h4 className="mdl-subtitle">For Visa/Mastercard &amp; Discover Holders</h4>
                    <p>
                      The verification number is a 3-digit number printed on the back of your card.
                      It appears after and to the right of your card number.
                    </p>
                    <p className="util-txt-center">
                      <img src={`${window._app.cdnPath}/step5/visa-cvv.jpg`} alt=""/>
                      <span className="d-block bold card-specification">3 Digit Card Verification Number</span>
                    </p>
                  </div>
                </div>
                <div className="sm-12 md-6">
                  <div className="grey-block">
                    <h4 className="mdl-subtitle">For American Express Cards</h4>
                    <p>
                      The American Express verification number is a small 4-digit number printed on the
                      front of your card on the right hand side.
                    </p>
                    <p className="util-txt-center right-block">
                      <img src={`${window._app.cdnPath}/step5/amex-cvv.jpg`} alt=""/>
                      <span className="d-block bold card-specification">4 Digit Card Verification Number</span>
                    </p>
                  </div>
                </div>

                <p className="sm-12 cvv-note">CVV2 information is not contained in the magnetic
                stripe information, nor does it appear on sales receipts.</p>
              </div>
            </div>

          </Modal>
        )}
      </PaymentContext.Consumer>
    );
  }
}

export default CardVerificationValueModalWrapper;



// WEBPACK FOOTER //
// ./js/components/step5/payment/CardVerificationValueModalWrapper.js